// Init empty widgets list
var list = [];

function WidgetList() {
    /**
     * Add Object {widgetId : widgetObject} to list
     * @param {String} id - widget id
     * @param {Widget} widget - Widget class instance
     */
    this.put = function(id, widget) {
        var newWidget = {};
        newWidget[id] = widget;
        list.push(newWidget);
    }

    /**
     * Returns widget, or null
     * @param {String} id - widget id
     * @returns {Widget} or null, if no widget by id
     */
     this.getById = function(id) {
        var widgetsById = list.filter(function(widget) {
            var widgetId = Object.keys(widget)[0];
            return widgetId === id;
        });
        if (widgetsById.length) {
            return widgetsById[0][id];
        }

        return null;
    }
}

export default WidgetList;